import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';

import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import { bulkPackingSlipsDirectPrint, bulkPackingSlipsDownload } from '../../../../store/orders/orders.actions';
import PrintDocumentMenuItem from '../../../print-document-menu-item';
import { usePackingSlipDisabledCheck } from '../hooks/use-packing-slip';
import { useInventoryAllocation } from '../../../../hooks/inventory/use-inventory-allocation';

export const PackingSlip = ({ fulfillmentPlans, printSetting, salesOrders }) => {
  const { isDisabled, onClick } = usePackingSlipDisabledCheck({
    fulfillmentPlans,
    salesOrders,
  });
  const { allocateInventory } = useInventoryAllocation();

  const onPrint = useCallback(() => {
    const fulfillmentPlanIds = fulfillmentPlans.map((plan) => plan.fulfillmentPlanId);
    allocateInventory(fulfillmentPlanIds, bulkPackingSlipsDirectPrint());
  }, [allocateInventory, fulfillmentPlans]);
  const onDownload = useCallback(() => {
    const fulfillmentPlanIds = fulfillmentPlans.map((plan) => plan.fulfillmentPlanId);
    allocateInventory(fulfillmentPlanIds, bulkPackingSlipsDownload());
  }, [allocateInventory, fulfillmentPlans]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSetting, onPrint, onDownload),
    [onDownload, onPrint, printSetting],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.PackingSlip.documentNameTranslation}
      onClick={onClick}
    />
  );
};

PackingSlip.propTypes = {
  fulfillmentPlans: PropTypes.array.isRequired,
  printSetting: PropTypes.any,
  salesOrders: PropTypes.array.isRequired,
};
